import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { downloadReportFile } from "../../../../helper/downloadReportFile";
import StatusBadge from "../../../../components/shared/StatusBadge";

/**
 * Table displaying Embryo Transfer Permits.
 * Adheres strictly to EAHS shared horseResultTable & theadHorseSelect styles,
 * matching the exact action/download pattern used in AllServicesRequestsPage.
 *
 * @param {Object} props
 * @param {Array} props.permits - List of permits
 */
export default function EmbryoPermitTable({ permits = [] }) {
    const { translate } = useTranslate();

    return (
        <div className="scrolableTable mb-main">
            <table className="table table-striped table-bordered rtl horseResultTable">
                <thead className="theadHorseSelect">
                    <tr>
                        <th className="text-center">
                            {translate("web.certificateReferenceNumber", "Permit Ref. No")}
                        </th>
                        <th className="text-center">
                            {translate("web.mare", "Mare")}
                        </th>
                        <th className="text-center">
                            {translate("web.activeFromDate", "Active From")}
                        </th>
                        <th className="text-center">
                            {translate("web.activeToDate", "Active To")}
                        </th>
                        <th className="text-center">
                            {translate("web.status", "Status")}
                        </th>
                        <th className="text-center">
                            {translate("web.download", "Download")}
                        </th>
                    </tr>
                </thead>
                <tbody className="text-center">
                    {permits.length > 0 ? (
                        permits.map((item, index) => {
                            const rowId = item.embryoOocyteTransferPermitId || item.serviceId || index;
                            const mareDisplayName =
                                item.mareRegistrationNumber && item.mareName
                                    ? `${item.mareRegistrationNumber} - ${item.mareName}`
                                    : item.mareRegistrationNumber || item.mareName || "-";

                            const rawReportUrl = item.reportUrl;

                            return (
                                <tr key={rowId}>
                                    <td style={{ fontSize: 13 }}>
                                        {item.permitReferenceNumber || "-"}
                                    </td>
                                    <td style={{ fontSize: 13, fontWeight: "bold" }}>
                                        {mareDisplayName}
                                    </td>
                                    <td style={{ fontSize: 13 }}>
                                        {item.permitStartDate}
                                    </td>
                                    <td style={{ fontSize: 13 }}>
                                        {item.permitExpiryDate}
                                    </td>
                                    <td>
                                        <StatusBadge status={item.status} statusColor={item.statusColor} />
                                    </td>
                                    <td>
                                        {rawReportUrl ? (
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-decoration-none"
                                                style={{ color: "inherit", cursor: "pointer" }}
                                                onClick={() => downloadReportFile(rawReportUrl)}
                                                title={translate("web.download", "Download")}
                                            >
                                                <i className="fa fa-download"></i>
                                            </button>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={6} className="text-center py-4" style={{ color: "#888" }}>
                                {translate("web.noDataFound", "No Data Found !")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
